import { Option } from '@/core/interfaces';
import i18n from '@/i18n';

const languages = process.env.VITE_LANGUAGES?.split('|');

export const languagesData: Option[] = [];

export const getLanguagesData = () => {
	const data: Option[] = [];
	languages?.map((lang) => {
		data.push({
			id: data.length + 1,
			name: i18n.t(`languages.${lang}`), // re-fetch translation
			code: lang,
		});
	});
	return data;
};
